import { defineStore } from "pinia";
import * as moment from "moment";

export const datePicker = defineStore({
  id: "datePicker",
  state: () => ({
    datePicker: [],
  }),
  actions: {
    setDatePicker(date) {
      let datesToSet = [];
      
      // 1. Ưu tiên sử dụng trực tiếp tham số truyền vào
      if (date && date.length === 2) {
        datesToSet = date.map((item) => new Date(item));
      } 
      // 2. Nếu không truyền tham số, mới fallback về localStorage
      else if (localStorage.getItem("dateSelect")) {
        let dates = localStorage.getItem("dateSelect");
        let a = dates.split(",");
        datesToSet = a.map((item) => new Date(item));
      }

      // 3. Kiểm tra limit từ store timeRange
      const storeTimeRange = timeRange();
      const limit = storeTimeRange.showTimeRange;
      
      if (limit > 0 && datesToSet && datesToSet.length === 2) {
        const d1 = moment(datesToSet[0]);
        const d2 = moment(datesToSet[1]);
        const diffDays = d2.diff(d1, "days") + 1;
        
        if (diffDays > limit) {
          const d1_new = moment(datesToSet[1]).subtract(limit - 1, "days").toDate();
          datesToSet = [d1_new, datesToSet[1]];
        }
      }

      // 4. Tự động đồng bộ với localStorage bên trong store
      if (datesToSet && datesToSet.length === 2) {
        localStorage.setItem("dateSelect", [
          datesToSet[0].toISOString(),
          datesToSet[1].toISOString(),
        ]);
      }

      // 5. Nếu giá trị không thực sự thay đổi thì không gán lại state.
      // setDatePicker luôn tạo array mới, nên gán vô điều kiện sẽ làm mọi watcher
      // trên showDatePicker fire dù ngày y nguyên (vd: timeRange.setTimeRange gọi
      // lại setDatePicker với chính giá trị hiện tại). Các watcher đó có thể bắn
      // router.push và hủy navigation đang chạy của người dùng.
      const prev = this.datePicker;
      const unchanged =
        prev?.length === 2 &&
        datesToSet?.length === 2 &&
        prev[0]?.getTime() === datesToSet[0].getTime() &&
        prev[1]?.getTime() === datesToSet[1].getTime();
      if (unchanged) return;

      this.datePicker = datesToSet;
    },
  },
  getters: {
    showDatePicker: (state) => state.datePicker,
  },
});

export const timeRange = defineStore({
  id: "timeRange",
  state: () => ({
    timeRange: 0,
  }),
  actions: {
    setTimeRange(limit) {
      this.timeRange = limit;
      if (limit > 0) {
        const storeDatePicker = datePicker();
        const currentDates = storeDatePicker.showDatePicker;
        if (currentDates && currentDates.length === 2) {
          // Chỉ cần gọi setDatePicker để tự động dịch ngày và cập nhật localStorage
          storeDatePicker.setDatePicker(currentDates);
        }
      }
    },
  },
  getters: {
    showTimeRange: (state) => state.timeRange,
  },
});
